import React, { useEffect, useRef, useState } from "react";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { fromLonLat } from "ol/proj";
import { Point } from "ol/geom";
import { Feature } from "ol";
import OSM from "ol/source/OSM";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import Overlay from "ol/Overlay";
import mapIcon from "../../mapIcon.png";
//import { defaults as defaultControls } from "ol/control";

const BuildingsMap = ({buildings, setMapClicked, mapClicked}) => {

    const popupRef = useRef(null);
    const [, setMap] = useState(null);
    const [vectorSource] = useState(new VectorSource());



    useEffect(() => {
      const firstBuilding = buildings.find(b => b.city === buildings.reduce((acc, b) => {
        acc[b.city] = (acc[b.city] || 0) + 1;
        return acc[b.city] > (acc[acc.maxCity] || 0) ? (acc.maxCity = b.city, acc) : acc;
    }, { maxCity: null }).maxCity);

        // Initialize OpenLayers map
        const newMap = new Map({
          target: "map",
          layers: [
            new TileLayer({
              source: new OSM({
                attributions: [],
              }),
            }),
          ],
          view: new View({
            // Default center (Austria) [13.3458, 47.6965]
            center: fromLonLat([firstBuilding.partner_longitude, firstBuilding.partner_latitude]), 
            zoom: 10,
          }),
          controls: [],
        });
    
        // Create vector layer for markers
        const vectorLayer = new VectorLayer({
          source: vectorSource,
        });
    
        // Add layer to map
        newMap.addLayer(vectorLayer);
        setMap(newMap);
    
        // Popup overlay
        const popupOverlay = new Overlay({
          element: popupRef.current,
          positioning: "bottom-center",
          stopEvent: false,
          offset: [0, -10],
        });
        newMap.addOverlay(popupOverlay);
    
        // Click event for popups
        newMap.on("singleclick", (event) => {
          const feature = newMap.forEachFeatureAtPixel(event.pixel, (feat) => feat);
    
          if (feature) {
            const coordinates = event.coordinate;
            const description = feature.get("description");
    
            popupOverlay.setPosition(coordinates);
            popupRef.current.style.display = "block";
            popupRef.current.innerHTML = description;
            popupRef.current.innerHTML += `<div class="row mt-2 text-center" style="border-top: 1px solid #ccc; padding-top: 5px;">
              <div class="col-4 text-center border-end">
                <a href="/hw/dashboard/gebaeude/anlagen/${feature.get('id')}/" class="link-energo">Anlagen</a>
              </div>
              <div class="col-4 text-center border-end">
                <a href="/hw/dashboard/energieliefervertraege/gebaeude/${feature.get('id')}/" class="link-energo">Lieferverträge</a>
              </div>
              <div class="col-4 text-center">
                <a href="/hw/dashboard/gebaeude/dokumente/${feature.get('id')}/" class="link-energo">Dokumente</a>
              </div>
            </div>`;
          } else {
            popupRef.current.style.display = "none";
          }
        });
    
        return () => newMap.dispose();
      }, [vectorSource, buildings]);
    
      // Function to add a marker on the map
      const addMarker = (coordinates, description, id) => {
        const markerFeature = new Feature({
          geometry: new Point(fromLonLat(coordinates)),
        });
    
        markerFeature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src: mapIcon,
              scale: 1,
            }),
          })
        );
    
        markerFeature.set("description", description);
        markerFeature.set("id", id);
        vectorSource.addFeature(markerFeature);
      };
    
      // Fetch coordinates for each address
      useEffect(() => {
        if (buildings.length > 0) {
          buildings.forEach(b => {
            addMarker([b.partner_longitude, b.partner_latitude], b.name, b.id);
          });
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [buildings]);

    return (
      <>
        <div 
          id="map" 
          style={{ width: "100%", height: mapClicked? 350:150, marginTop: -23}}
          onClick={() => {setMapClicked(true)}}
        />
        <div ref={popupRef} className="popup" style={{ 
          position: "absolute", 
          backgroundColor: "white", 
          padding: "5px", 
          borderRadius: "5px", 
          display: "none", 
          fontSize: 12,
          minWidth: 350,
          fontWeight: 600,
        }} />
      </>
    )
}

export default BuildingsMap;